export enum ValidationType {
    Required = 0,
    Cell = 1,
    Number = 5,
    Email = 7,
}